import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';

import { useCurrentUser } from '@/core/store/auth/authSelectors';

export const useTrackMatomoUserId = (): void => {
	const currentUser = useCurrentUser();
	const { pushInstruction } = useMatomo();

	useEffect(() => {
		if (currentUser?.id) {
			pushInstruction('setUserId', currentUser.id);
		} else {
			pushInstruction('resetUserId');
		}
	}, [currentUser?.id, pushInstruction]);
};
